import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Col, Image, Row } from 'react-bootstrap'
import { visionBgImage } from '../../assets'

export default function VisionSection() {
  return (
    <Row className='vision-section mx-0'>
      <Col md={6} className='vision-description d-flex flex-column justify-content-center'>
        <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
          <h2 style={{ fontWeight: '800', color: '#536936', textAlign: 'start' }}>Our vision for a <br />better future</h2>
        </AnimationOnScroll>
        <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
          <p align='left' style={{ fontWeight: '500', fontSize: '1.1em' }}>Kaptain plywood sources wood from tropical plantations,
            and essentially all of the wood entering our factory is
            utilized within our manufacturing process, which helps
            in minimum wastage of product and minimize the harm to
            our sensitive ecosystem.</p>
        </AnimationOnScroll>
      </Col>
      <Col md={6}>
        <Image src={visionBgImage} className='vision-image' />
      </Col>

    </Row>
  )
}
